export default {"src":"/_next/static/image/public/images/ic_logout_grey.8213b71e80c3a51c0086f75b6b7c01d6.svg","height":20,"width":20};